// extracted by mini-css-extract-plugin
export default {"productGallery":"uH-z","inQuickShop":"vH-z"};